const MuiToolbar = {
  styleOverrides: {
    root: {
      padding: '0 18px',
    },
  },
};

export default MuiToolbar;
